import {isFeatureEnabled} from '@github-ui/feature-flags'
import {useLayoutBaseRepository, useLayoutPullRequestId} from '@github-ui/pull-requests/pull-request-store-selectors'

/**
 * Builds the `modelsUrl` that surfaces the Copilot "Fix with Copilot" model picker in the
 * Files Changed view, or `undefined` when the picker is disabled.
 *
 * The URL points at the PR-aware coding-agent models proxy on the **base** repository — for
 * fork PRs the endpoint lives on the base repo, not the head repo. `pull_id` is the numeric
 * database id so the proxy can compute the PR's current model.
 *
 * Gated behind `ccr_files_changed_model_picker` (default off); returns `undefined` when the
 * flag is off so downstream consumers skip rendering the picker entirely.
 */
export function useFilesChangedModelPickerModelsUrl(): string | undefined {
  const pullRequestId = useLayoutPullRequestId()
  const baseRepository = useLayoutBaseRepository()

  if (!isFeatureEnabled('ccr_files_changed_model_picker')) return undefined

  return `/${baseRepository.ownerLogin}/${baseRepository.name}/copilot/coding_agent/models?pull_id=${pullRequestId}`
}
